import { z } from "zod";
// `POST /onboarding/upload` is multipart/form-data (NOT JSON-schema validated);
// the server parses + validates fields manually. Accepted form fields:
//   Required: email, company_name, company_slug
//   Optional: company_code, legal_name, contact_email, contact_phone, website_url,
//             address_line1, address_line2, city, state_region, postal_code,
//             country_code (2-letter), default_timezone (default UTC),
//             default_currency (3-letter, default INR), logo_file (file)
// Only the response is described as a contract here.
export const onboardingUploadResponse = z.object({
    tenantId: z.string().uuid(),
    logoUrl: z.string().url().nullable(),
});
//# sourceMappingURL=onboarding.schemas.js.map